import { Box } from "@hightouch/htui";

import type { Edge } from "@atlaskit/pragmatic-drag-and-drop-hitbox/closest-edge";

/** Where a dragged task will land, drawn on the edge of the task it's beside. */
export const DropLine = ({ edge }: { edge: Edge }) => (
  <Box
    aria-hidden
    position="absolute"
    left={0}
    right={0}
    height={0.5}
    bg="primary.base"
    zIndex={2}
    pointerEvents="none"
    {...(edge === "top" ? { top: "-1px" } : { bottom: "-1px" })}
  />
);
